import React, { useState } from "react";
import { Stack, Box, Typography } from "@mui/material";
import useResponsive from "../../hooks/useResponsive";
import Header from "../../layout/dashboard/header";
import TimesheetContent from "../../components/timesheet/TimesheetContent";
import { useQuery } from "@tanstack/react-query";
import { apiGetFacilityTimesheet } from "../../api/timesheet";
import { useNotificationService } from "../../components/notification";
import { TimesheetDetails } from "../../interface/timesheet";
import {
  PaginationDetails,
  PaginationDetailsDummyData,
} from "../../interface/api_request";

const TimeSheet: React.FC = () => {
  const isDesktop = useResponsive("down", "lg", "xl");
  const isMedium = useResponsive("down", "md", "xl");
  const { showNotification } = useNotificationService();
  const [timesheet_list, setTimesheet_list] = useState<TimesheetDetails[]>([]);
  const [filter_data, setFilter_data] = useState("");

  // set up pagination state
  const [pagination_state, setPagination_state] = useState<PaginationDetails>(
    PaginationDetailsDummyData,
  );

  const { data, isLoading } = useQuery({
    queryKey: ["facilityTimesheet", pagination_state.page, filter_data],
    queryFn: async () => {
      const result = await apiGetFacilityTimesheet(
        `${pagination_state.page}`,
        filter_data,
      );

      if (result?.status === "error") {
        if ("msg" in result) {
          showNotification(result.msg ?? "", "error");
          return {};
        }
        return [];
      }

      if ("data" in result) {
        if (result?.data?.meta) {
          setPagination_state({
            hasNextPage: result.data.meta.hasNextPage,
            hasPrevPage: result.data.meta.hasPrevPage,
            nextPage: result.data.meta.nextPage,
            page: result.data.meta.page,
            pages: result.data.meta.pages,
            prevPage: result.data.meta.prevPage,
            reads: result.data.meta.reads,
            totalDocs: result.data.meta.totalDocs,
            unReads: result.data.meta.unReads,
          });
        }

        if (result?.data?.data?.length > 0) {
          setTimesheet_list(result.data.data);
        } else {
          setTimesheet_list([]);
        }
      }

      return result?.data || [];
    },
  });

  return (
    <>
      {/* Header Menu */}
      <Header>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "1rem",
            height: isMedium ? 60 : 75,
          }}
        >
          <Stack direction={"row"} alignItems={"center"} sx={{ gap: "10px" }}>
            <Typography
              variant={"subtitle1"}
              sx={{
                fontWeight: 500,
                fontFamily: "Lexend",
                color: "#2F66F4",
              }}
            >
              Timesheet
            </Typography>
          </Stack>
          {!isDesktop && <Stack direction={"row"} sx={{ gap: 3 }}></Stack>}
        </Box>
      </Header>

      <TimesheetContent
        setFilterData={setFilter_data}
        paginationState={pagination_state}
        setPaginationState={setPagination_state}
        timesheetList={timesheet_list}
        loading={isLoading}
      />
    </>
  );
};

export default TimeSheet;
